export const SHARED_HOT_CLUB_HTTP_GLOBAL_HEADERS =
  '__SHARED_HOT_CLUB_HTTP_GLOBAL_HEADERS__' as const

export const SHARED_HOT_CLUB_HTTP_INSTANCES = '__SHARED_HOT_CLUB_HTTP_INSTANCES__' as const

export const SHARED_HOT_CLUB_QUERY_CLIENT = '__SHARED_HOT_CLUB_QUERY_CLIENT__' as const

export const HTTP_STATUS_CODE = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503
} as const

const DEFAULT_STALE_TIME_IN_MINUTES = 30
const ONE_MINUTE_IN_SECONDS = 60
const ONE_SECOND_IN_MILLISECONDS = 1000

export const DEFAULT_STALE_TIME =
  DEFAULT_STALE_TIME_IN_MINUTES * ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS // 30 minutes

export const PROVIDER_INSTANCE = '__HOT_PROVIDER__'

export const PROVIDER_DEFAULT_API = '/provider'

export const EVENTS_NAME = {
  REQUEST_SUCCESS: 'hotClubHttp:request:onSuccess',
  REQUEST_ERROR: 'hotClubHttp:request:onError',
  RESPONSE_SUCCESS: 'hotClubHttp:response:onSuccess',
  RESPONSE_ERROR: 'hotClubHttp:response:onError'
} as const

export const COUNT_REMOVE_CONTROLLER = 2000

export const REQUEST_TIMEOUT = 20000
